import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
// import LoadingComponent from '../loadingComponent'; // Remove this import
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Skeleton } from 'primereact/skeleton'; // Add this import
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import './styles.scss';
import { FaWhatsapp, FaMoneyBillWave, FaAddressCard, FaPlusCircle, FaEye, FaCheckCircle } from 'react-icons/fa';
import { SiGmail } from 'react-icons/si';

class CommunicationDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showAddBalanceDialog: false,
            balanceAmount: null,
            stats: {
                whatsapp: 0,
                sms: 0,
                email: 0,
                balance: 0,
            }
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.fetchDashboardData();
    }

    fetchDashboardData = async () => {
        this.setState({ isLoading: true });
        try {
            // Use the thirdParty endpoint to get all data in one call
            const thirdPartyResponse = await this.service.get(`${baseUrlAdmin}/organization/thirdPartySettings`, true);

            if (thirdPartyResponse?.res?.success) {
                const thirdPartyData = thirdPartyResponse.res.data;
                this.setState({
                    stats: {
                        whatsapp: thirdPartyData.whatsapp?.creditsUsed || 0,
                        sms: thirdPartyData.sms?.creditsUsed || 0,
                        email: thirdPartyData.email?.creditsUsed || 0,
                        balance: thirdPartyData.totalBalance || 0,
                    }
                });
            }
        } catch (err) {
            this.toast?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to fetch communication stats',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    formatNumberWithCommas = (number, decimals = null) => {
        if (number == null) return "0";
        let num = Number(number);
        if (isNaN(num)) return "0";
        if (decimals !== null) {
            num = num.toFixed(decimals);
        }
        // Remove trailing zeros after decimal if decimals is set
        let parts = num.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.length > 1 ? `${parts[0]}.${parts[1].replace(/0+$/, "")}`.replace(/\.$/, "") : parts[0];
    };

    showAddBalancePopup = () => {
        this.setState({ showAddBalanceDialog: true, balanceAmount: null });
    };

    hideAddBalancePopup = () => {
        this.setState({ showAddBalanceDialog: false, balanceAmount: null });
    };

    handleAddBalance = async () => {
        const { balanceAmount } = this.state;

        if (!balanceAmount || balanceAmount <= 0) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please enter a valid balance amount',
                life: 3000
            });
            return;
        }

        this.setState({ isLoading: true });
        try {
            const response = await this.service.post(`${baseUrlAdmin}/organization/totalBalance/increment`, { amount: balanceAmount }, true);

            if (response?.res?.success) {
                this.toast?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: `Balance of ₹${this.formatNumberWithCommas(balanceAmount)} added successfully`,
                    life: 3000
                });

                // Update the local stats
                this.setState(prevState => ({
                    stats: {
                        ...prevState.stats,
                        balance: prevState.stats.balance + balanceAmount
                    }
                }));

                this.hideAddBalancePopup();
            } else {
                throw new Error('Failed to add balance');
            }
        } catch (err) {
            this.toast?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to add balance. Please try again.',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    renderShimmerCards = () => (
        <div className='dashboard-summary-cards'>
            <div className='cards'>
                <div className="finance-card">
                    <div className="finance-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="finance-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="finance-card">
                    <div className="finance-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="10rem" height="1rem" />
                    </div>
                    <div className="finance-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
            <div className='cards'>
                <div className="finance-card">
                    <div className="finance-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="finance-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="finance-card">
                    <div className="finance-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="7rem" height="1rem" />
                    </div>
                    <div className="finance-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
        </div>
    );

    renderShimmerQuickActions = () => (
        <div className='quick-actions-container'>
            <Skeleton width="8rem" height="1.25rem" className="mb-3" />
            <div className="flex justify-content-between align-items-center quick-actions">
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="5rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
            </div>
        </div>
    );

    render() {
        const { stats, isLoading, showAddBalanceDialog, balanceAmount } = this.state;

        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#E6E8EA',
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };

        const quickAmounts = [500, 1000, 2000, 5000];

        if (isLoading) {
            return (
                <div style={containerStyle}>
                    <div className="finance-dashboard-container">
                        <div className="dashboard-main-section">
                            {this.renderShimmerCards()}
                            {this.renderShimmerQuickActions()}
                        </div>
                    </div>
                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                </div>
            );
        }

        return (
            <div style={containerStyle}>
                <div className="finance-dashboard-container">
                    <div className="dashboard-main-section">
                        <div className='dashboard-summary-cards'>
                            <div className='cards'>
                                <div className="finance-card">
                                    <div className="finance-icon-group">
                                        <FaWhatsapp className="finance-icon" style={{ color: "#25D366" }} />
                                        <span className="finance-label">Whatsapp Count</span>
                                    </div>
                                    <div className="finance-divider"></div>
                                    <div className="finance-amount">
                                        {this.formatNumberWithCommas(stats.whatsapp)}
                                    </div>
                                </div>
                                <div className="finance-card">
                                    <div className="finance-icon-group">
                                        <FaMoneyBillWave className="finance-icon" style={{ color: "#2D7FF9" }} />
                                        <span className="finance-label">Wallet Balance</span>
                                    </div>
                                    <div className="finance-divider"></div>
                                    <div className="finance-amount">
                                        ₹{this.formatNumberWithCommas(stats.balance, 2)}
                                    </div>
                                </div>
                            </div>
                            <div className='cards'>
                                <div className="finance-card">
                                    <div className="finance-icon-group">
                                        <FaAddressCard className="finance-icon" style={{ color: "#000" }} />
                                        <span className="finance-label">SMS Count</span>
                                    </div>
                                    <div className="finance-divider"></div>
                                    <div className="finance-amount">
                                        {this.formatNumberWithCommas(stats.sms)}
                                    </div>
                                </div>
                                <div className="finance-card">
                                    <div className="finance-icon-group">
                                        <SiGmail className="finance-icon" style={{ color: "#EA4335" }} />
                                        <span className="finance-label">E Mail</span>
                                    </div>
                                    <div className="finance-divider"></div>
                                    <div className="finance-amount">
                                        {this.formatNumberWithCommas(stats.email)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='quick-actions-container'>
                            <h5 className="quick-actions-header">Quick Actions</h5>
                            <div className="flex justify-content-between align-items-center quick-actions">
                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/communicate-notification')}>
                                    <div className="add-balance-icon-bg">
                                        <FaPlusCircle className="add-balance-plus" />
                                    </div>
                                    <p className='quickActions-title'>Add Notification</p>
                                </div>
                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/templates-management')}>
                                    <div className="add-balance-icon-bg">
                                        <FaPlusCircle className="add-balance-plus" />
                                    </div>
                                    <p className='quickActions-title'>Add Template</p>
                                </div>
                                <div className="text-center quick-action-item" onClick={this.showAddBalancePopup}>
                                    <div className="add-balance-icon-bg">
                                        <FaPlusCircle className="add-balance-plus" />
                                    </div>
                                    <p className='quickActions-title'>Add Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modern Add Balance Dialog */}
                <Dialog
                    visible={showAddBalanceDialog}
                    onHide={this.hideAddBalancePopup}
                    header={null}
                    style={{ width: '450px' }}
                    modal
                    draggable={false}
                    className="modern-balance-dialog"
                >
                    <div className="balance-popup-container">
                        {/* Header */}
                        <div className="balance-popup-header">
                            <div className="balance-icon-container">
                                <FaMoneyBillWave className="balance-main-icon" />
                            </div>
                            <h2 className="balance-popup-title">Add Money to Wallet</h2>
                            <p className="balance-popup-subtitle">Choose an amount to add to your messaging balance</p>
                        </div>

                        {/* Current Balance Display */}
                        <div className="current-balance-display">
                            <span className="current-balance-label">Current Balance</span>
                            <span className="current-balance-amount">₹{this.formatNumberWithCommas(stats.balance)}</span>
                        </div>

                        {/* Quick Amount Selection */}
                        <div className="quick-amounts-section">
                            <h4 className="section-title">Quick Select</h4>
                            <div className="quick-amounts-grid">
                                {quickAmounts.map((amount) => (
                                    <div
                                        key={amount}
                                        className={`quick-amount-card ${balanceAmount === amount ? 'selected' : ''}`}
                                        onClick={() => this.setState({ balanceAmount: amount })}
                                    >
                                        <span className="quick-amount-text">₹{this.formatNumberWithCommas(amount)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Custom Amount Input */}
                        <div className="custom-amount-section">
                            <h4 className="section-title">Or Enter Custom Amount</h4>
                            <div className="custom-amount-input-container">
                                <span className="currency-symbol">₹</span>
                                <InputNumber
                                    value={balanceAmount}
                                    onValueChange={(e) => this.setState({ balanceAmount: e.value })}
                                    placeholder="Enter amount"
                                    min={1}
                                    max={100000}
                                    className="custom-amount-input"
                                    useGrouping={false}
                                />
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="balance-popup-actions">
                            <Button
                                label="Cancel"
                                className="cancel-button"
                                onClick={this.hideAddBalancePopup}
                            />
                            <Button
                                label={`Pay ₹${balanceAmount ? this.formatNumberWithCommas(balanceAmount) : '0'}`}
                                className="pay-button"
                                onClick={this.handleAddBalance}
                                disabled={!balanceAmount || balanceAmount <= 0}
                                icon="pi pi-credit-card"
                            />
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {/* {isLoading && <LoadingComponent />} */}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo || {},
});

export default connect(mapStateToProps, {})(Authentication(withRouter(CommunicationDashboard)));